import * as types from './types';

export const setLoading = (isLoading) => ({
  type: types.REFERENCE_SET_LOADING,
  isLoading
});

export const setReferenceCodeWorkflowStatus = (status) => ({
  type: types.REFERENCE_SET_CODE_STATUS,
  status
});

export const validateCandidateReferenceCode = (code) => ({
  type: types.REFERENCE_VALIDATE_CANDIDATE_REFERENCE_CODE,
  code
});

export const declineCandidateReference = (code, reason) => ({
  type: types.REFERENCE_DECLINE_CANDIDATE_REFERENCE,
  code,
  reason
});

export const getCandidateReferenceDetailsSummary = (code) => ({
  type: types.REFERENCE_GET_CANDIDATE_REFERENCE_DETAILS_SUMMARY,
  code
});

export const setCandidateReference = (candidateReference) => ({
  type: types.REFERENCE_SET_CANDIDATE_REFERENCE,
  candidateReference
});

export const  completeCandidateReference = (code, candidateReference) => ({
  type: types.REFERENCE_COMPLETE_CANDIDATE_REFERENCE,
  code,
  candidateReference
});

export const printCandidateReference = (code) => ({
  type: types.REFERENCE_PRINT_CANDIDATE_REFERENCE,
  code
});


// WEBPACK FOOTER //
// ./src/actions/references/index.js